import React, { Component } from 'react';
import PropTypes from 'prop-types';
import client from '../apollo';
import returnInvoiceQuery from '../graphql/returnInvoiceQuery';
import dealerAccountsQuery from '../graphql/dealerAccountsQuery';
import Certificate from '../views/ReturnCertificate/certificate';

class ReturnCertificate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      returnInvoice: '',
      dealerData: [],
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const { returnInvoiceId } = match.params;

    const dealerQuery = dealerNumber => {
      client
        .query({
          query: dealerAccountsQuery,
          variables: {
            dealerNumber: `${dealerNumber}`,
          },
          fetchPolicy: 'network-only',
        })
        .then(({ data }) => {
          const { dealerAccounts } = data;
          this.setState({
            dealerData: dealerAccounts,
          });
        })
        .catch(() => {
          this.setState({
            dealerData: [],
          });
        });
    };

    client
      .query({
        query: returnInvoiceQuery,
        variables: {
          id: returnInvoiceId,
        },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        const { returnInvoice } = data;
        const {
          transaction: { dealerNumber },
        } = returnInvoice;
        this.setState({
          returnInvoice,
        });
        dealerQuery(dealerNumber);
      })
      .catch(() => {
        this.setState({
          returnInvoice: '',
        });
      });
  }

  render() {
    const { returnInvoice, dealerData } = this.state;
    return (
      <div className='certificate'>
        {returnInvoice && (
          <Certificate
            returnInvoice={returnInvoice}
            dealerData={dealerData}
          />
        )}
      </div>
    );
  }
}

ReturnCertificate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      returnInvoiceId: PropTypes.string,
    }),
  }).isRequired,
};

export default ReturnCertificate;
